/**
 * Product launch page — Webbysend AJAX signup + gallery lightbox.
 */
(function () {
  'use strict';

  function whenJQueryReady(fn) {
    if (window.jQuery) {
      fn(window.jQuery);
      return;
    }
    document.addEventListener('DOMContentLoaded', function () {
      if (window.jQuery) {
        fn(window.jQuery);
      }
    });
  }

  function isSendySuccess(data) {
    var text = (data || '').toString().trim();
    return text === 'true' || text === '1';
  }

  function showNotice($status, type, message) {
    $status
      .removeAttr('hidden')
      .attr('class', 'product-launch-notify__status msg-notice msg-notice__' + type)
      .text(message);

    $status[0].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
  }

  function parseSendyResponse(data, $form) {
    var text = (data || '').toString().trim();
    var successMsg = $form.data('success-message') || "You're on the list!";
    var alreadyMsg = $form.data('already-subscribed-message') || "You're already on the list.";
    var errorMsg = $form.data('error-message') || 'Something went wrong. Please try again.';

    if (isSendySuccess(text)) {
      return { type: 'success', message: successMsg };
    }
    if (text === 'Already subscribed.') {
      return { type: 'success', message: alreadyMsg };
    }
    if (text === 'Invalid email address.') {
      return { type: 'error', message: 'Please enter a valid email address.' };
    }
    if (text === 'Some fields are missing.') {
      return { type: 'error', message: 'Please enter your email address.' };
    }
    if (text) {
      return { type: 'error', message: text };
    }
    return { type: 'error', message: errorMsg };
  }

  function initWebbysendForms($) {
    $('.form-webbysend-ajax').each(function () {
      var $form = $(this);
      if ($form.data('webbysendBound')) {
        return;
      }

      var $status = $('#' + $form.attr('id') + '-status');
      var $submit = $form.find('[type="submit"]');
      var submitText = $submit.text();

      $form.on('submit', function (e) {
        e.preventDefault();

        var email = $.trim($form.find('[name="email"]').val());
        if (!email) {
          showNotice($status, 'error', 'Please enter your email address.');
          return;
        }

        $submit.prop('disabled', true).text('Submitting…');
        $status.attr('hidden', true).empty();

        $.ajax({
          url: $form.attr('action'),
          type: 'POST',
          data: {
            email: email,
            hp: $form.find('[name="hp"]').val(),
            referrer: window.location.href,
          },
          dataType: 'text',
        })
          .done(function (data) {
            var result = parseSendyResponse(data, $form);
            showNotice($status, result.type, result.message);
            if (result.type === 'success') {
              $form.find('[name="email"]').val('');
            }
          })
          .fail(function (xhr) {
            var responseText = (xhr.responseText || '').toString().trim();
            var message;

            if (responseText) {
              message = responseText;
            } else if (xhr.status === 0) {
              message =
                'Unable to reach the signup service from this page. Check that signup.php allows this site origin.';
            } else {
              message =
                $form.data('error-message') || 'Unable to subscribe right now. Please try again.';
            }

            showNotice($status, 'error', message);
          })
          .always(function () {
            $submit.prop('disabled', false).text(submitText);
          });
      });

      $form.data('webbysendBound', true);
    });
  }

  function initLaunchLightbox($) {
    var $container = $('.product-launch-section').first();
    if (!$container.length || !$.fn.magnificPopup) {
      return;
    }
    if ($container.data('mfpInit')) {
      return;
    }

    $container.magnificPopup({
      delegate: 'a.product-launch-lightbox',
      type: 'image',
      gallery: {
        enabled: true,
        navigateByImgClick: true,
      },
      mainClass: 'mfp-appear-anm mfp-img-mobile',
      removalDelay: 300,
      closeOnContentClick: true,
      image: {
        verticalFit: true,
      },
    });
    $container.data('mfpInit', true);
  }

  whenJQueryReady(function ($) {
    $(function () {
      initWebbysendForms($);
      initLaunchLightbox($);
    });
    $(window).on('load', function () {
      initLaunchLightbox($);
    });
  });
})();
